// extracted by mini-css-extract-plugin
module.exports = {"background":"App_diet_background__MSkW-"};